import React from "react";
import PropTypes from "prop-types";
import { useLeftBar } from "../../context/LeftBar";
import NavItem from "./MenuItem/NavItem";

import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import ContactSupportOutlinedIcon from "@mui/icons-material/ContactSupportOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import StarIcon from "@mui/icons-material/Star";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import styles from "../LeftSideMenu/styles.css";

function LeftSideMenu() {
  const { leftBarOpened, setLeftBarOpened } = useLeftBar();
  return (
    <div
      className={
        leftBarOpened ? "leftSideMenu is-opened" : "leftSideMenu  is-closed"
      }
    >
      <div className="leftSideHeader">
        <button
          type="button"
          onClick={() => {
            setLeftBarOpened(!leftBarOpened);
          }}
          className={leftBarOpened ? "button-menu" : "button-menu align-left"}
        >
          {leftBarOpened ? <ArrowBackIcon /> : <ArrowForwardIcon />}
        </button>
      </div>

      <div className="leftSideContent">
        {leftBarOpened && (
          <h3 className="leftSideContentTitle"> dashboard P3M </h3>
        )}
        <ul>
          <NavItem
            muiIcon={<AssessmentOutlinedIcon />}
            name="Dashboard"
            path="/overview"
          />
        </ul>
        <ul>
          <NavItem
            muiIcon={<StarIcon color="#000B72" />}
            name="TOP Produtos"
            path="/top-10"
          />
        </ul>

        {leftBarOpened && <h3 className="leftSideContentTitle">AJUDA</h3>}
        <ul>
          <NavItem
            muiIcon={<DescriptionOutlinedIcon />}
            name="Regras do dashboard"
            path="/regras"
          />
        </ul>
        <ul>
          <NavItem
            muiIcon={<ContactSupportOutlinedIcon />}
            name="Perguntas Frequentes"
            path="/faq"
          />
        </ul>
      </div>
    </div>
  );
}

LeftSideMenu.defaultProps = {
  app: null,
  config: null,
  logo: null,
};

LeftSideMenu.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  logo: PropTypes.object,
};

export default LeftSideMenu;
